import { render, staticRenderFns } from "./ViOverallDiscountAndPenalities.vue?vue&type=template&id=5acfaa09"
import script from "./ViOverallDiscountAndPenalities.vue?vue&type=script&lang=js"
export * from "./ViOverallDiscountAndPenalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports